import React, { ComponentProps } from 'react'

import BookedOfferDetailsButtonCTA from './BookedOfferDetailsCTA'

import TextButton from 'components/Luxkit/Button/TextButton'
import Group from 'components/utils/Group'
import LEBookingTag from 'tripPlanner/Tripkit/Common/LEBookingTag'
import { TripItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: TripItem
  size?: ComponentProps<typeof TextButton>['size']
}

export default function BookedOfferDetailsButtonAndTagView({
  item,
  size = 'medium',
}: Props) {
  return (
    <Group
      direction="vertical"
      tabletDirection="horizontal"
      gap={12}
      horizontalAlign="space-between"
      fullWidth
    >
      <LEBookingTag />
      <BookedOfferDetailsButtonCTA item={item} size={size} />
    </Group>
  )
}
